import { RootState } from 'store';

export const selectors = {
  selectPlans: (state: RootState) => state.studyPlans.plans,
  selectPhases: (state: RootState) => state.studyPlans.phases,
  selectPhasesMeta: (state: RootState) => state.studyPlans.meta,
};
